export default "__VITE_ASSET__sr9FJ3Fo__"